module.exports = __webpack_public_path__ + "img/14.80e7221e.jpg";